import { render, staticRenderFns } from "./ZoneInput.vue?vue&type=template&id=1221c27c&"
import script from "./ZoneInput.vue?vue&type=script&lang=ts&"
export * from "./ZoneInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports